import React, { useState, useEffect, useMemo } from "react";
import parse from "html-react-parser";
import debounce from "lodash.debounce";

const ParagraphDescription = ({ properties }) => {
  const [debouncedLabel, setDebouncedLabel] = useState(properties.text);

  // Debounce the label update
  const debouncedUpdate = useMemo(
    () => debounce((label) => setDebouncedLabel(label), 300), // 300ms debounce delay
    []
  );
  useEffect(() => {
    debouncedUpdate(properties.text);
  }, [properties.text, debouncedUpdate]);

  // Clean up the debounce function on unmount
  useEffect(() => {
    return () => {
      debouncedUpdate.cancel();
    };
  }, [debouncedUpdate]);

  const parsedLabel = useMemo(() => parse(debouncedLabel), [debouncedLabel]);

  return <>{parsedLabel}</>;
};

export default ParagraphDescription;
